var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"cat-tag",attrs:{"to":{ name: 'ResourcesCategory', params: { id: _vm.id } }}},[_c('TagIcon',{staticClass:"tag-icon"}),_c('span',[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }